var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-chart",
        {
          attrs: {
            forceFit: true,
            height: _vm.myHeight,
            data: _vm.data,
            scale: _vm.scale
          }
        },
        [
          _c("v-tooltip", { attrs: { shared: true } }),
          _c("v-axis", {
            attrs: {
              "data-key": "type",
              label: _vm.label,
              tickLine: _vm.tickLine
            }
          }),
          _c("v-interval", {
            attrs: {
              position: "item*count",
              label: _vm.labelInterval,
              opcaity: 1
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }